import { ExclamationCircleFilled } from '@ant-design/icons'
import { Button, Modal } from 'antd'
import useModal from 'hooks/useModal'
import { ComponentProps, FC, ReactNode } from 'react'

type ButtonProps = {
  label: string
  icon: ReactNode
  iconPosition?: 'start' | 'end'
  type?: 'link' | 'text' | 'default' | 'primary' | 'dashed' | undefined
  disabled?: boolean
} & ComponentProps<typeof Button>

type Props = {
  title: string
  button: ButtonProps
} & Omit<ComponentProps<typeof Modal>, 'title' | 'open' | 'onCancel'>

const ConfirmModal: FC<Props> = ({ title, button, onOk, okText = 'Yes', cancelText = 'No', children, ...rest }) => {
  const { isVisible: open, openModal, closeModal } = useModal()
  const handleOk = async (e: React.MouseEvent<HTMLButtonElement>) => {
    const result = await onOk?.(e)
    if (result !== undefined) {
      closeModal()
    }
  }

  return (
    <>
      <Button
        onClick={(e) => {
          e.stopPropagation()
          openModal()
        }}
        {...button}
        type={button.type || 'text'}
      >
        {button.label || ''}
      </Button>

      <Modal
        open={open}
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <ExclamationCircleFilled style={{ color: '#faad14', fontSize: 20 }} />
            {title}
          </div>
        }
        onOk={handleOk}
        onCancel={closeModal}
        okText={okText}
        cancelText={cancelText}
        okType="danger"
        {...rest}
      >
        {children}
      </Modal>
    </>
  )
}

export default ConfirmModal
